import React, { useState } from 'react'
import styles from './native_select_pay_type.module.css'
import strings from '../../strings/strings.json'
import NativeSelect from '@material-ui/core/NativeSelect'
import { withStyles } from '@material-ui/core/styles';
import InputBase from '@material-ui/core/InputBase';


const BootstrapInput = withStyles((theme) => ({
    root: {
        width: "200px",
        borderRadius: 15,
    },
    input: {
        borderRadius: 15,
        position: 'relative',
        backgroundColor: "rgba(17, 25, 42, 0.05)",
        border: '1px solid #ced4da',
        fontSize: 16,
        padding: '10px 26px 10px 12px',
        transition: theme.transitions.create(['border-color', 'box-shadow']),
        '&:focus': {
            borderRadius: 15,
        },
    },
}))(InputBase);


export const NativeSelectPayType = (props) => {

    const [currencyType, setCurrencyType] = useState('paypal')


    const onChangeHandler = (e) => {
        props.setCurrencyType(e.target.value)
        setCurrencyType(e.target.value)
    }
    return (
        <React.Fragment>
            <span className={styles.payTypeTitle}>{strings.plans_tranCurrecy}</span>
            <NativeSelect
                value={currencyType}
                onChange={event => onChangeHandler(event)}
                input={<BootstrapInput />}
            >
                <option value="paypal">Paypal</option>
                <option value="perfectmoney">Perfect Money</option>
                <option value="skrill">Skrill</option>
                <option value="bitcoin">Bitcoin</option>
                <option value="litecoin">Litecoin</option>
                <option value="bitcoincash">Bitcoin Cash</option>
                <option value="ethereum">Ethereum</option>
            </NativeSelect>
        </React.Fragment>
    )
}